import { render, staticRenderFns } from "./geoshape.vue?vue&type=template&id=08d18474&scoped=true"
import script from "./geoshape.vue?vue&type=script&lang=js"
export * from "./geoshape.vue?vue&type=script&lang=js"
import style0 from "./geoshape.vue?vue&type=style&index=0&id=08d18474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d18474",
  null
  
)

export default component.exports